<template>
<div >
<router-view></router-view>

</div>
</template>

<script setup>


</script>

<style>
body{
  background-image: url('./assets/background-img.png');
}
/* html, body {
  height: 100%;
  background: black;
}

#app {
  height: 100%;
  background: black;
} */
</style>
